export const HIGH_FREQUENCY_MUTATIONS = Object.freeze([
  'proposal/UPDATE_FILTERS',
  'proposal/SET_FILTER_SEARCHED',
]);

export function shouldPersistMutation(mutation) {
  return !HIGH_FREQUENCY_MUTATIONS.includes(mutation?.type);
}
